export default {
  '/styles/animation/gifs': {
    timings: [
      {
        portfolio_url: 'Darruda',
        start: 1,
        end: 3
      },
      {
        portfolio_url: 'GabriellaMussurakis',
        start: 4,
        end: 8
      },
      {
        portfolio_url: 'JulietteToma',
        start: 9,
        end: 12
      },
      {
        portfolio_url: 'TomBonson',
        start: 13,
        end: 16
      },
      {
        portfolio_url: 'KathrynRathke',
        start: 17,
        end: 19
      },
      {
        portfolio_url: 'MarioZucca',
        start: 20,
        end: 24
      },
      {
        portfolio_url: 'VeronicaCollignon',
        start: 25,
        end: 36
      },
      {
        portfolio_url: 'LaurenMortimer',
        start: 37,
        end: 39
      },
      {
        portfolio_url: 'MontanaForbes',
        start: 40,
        end: 43
      },
      {
        portfolio_url: 'SeasonofVictory',
        start: 44,
        end: 47
      },
      {
        portfolio_url: 'GabrielHollington',
        start: 48,
        end: 52
      },
      {
        portfolio_url: 'LauraGreenan',
        start: 53,
        end: 63
      },
      {
        portfolio_url: 'AlyssaDeAsis',
        start: 64,
        end: 67
      },
      {
        portfolio_url: 'AntonioSoares',
        start: 68,
        end: 70
      },
      {
        portfolio_url: 'LeeHodges',
        start: 71,
        end: 74
      }
    ]
  },
  '/styles/animation/2d': {
    timings: [
      {
        portfolio_url: 'Tapocketa',
        start: 1,
        end: 9
      },
      {
        portfolio_url: 'HenrySmith',
        start: 10,
        end: 16
      },
      {
        portfolio_url: 'PeterNizic',
        start: 17,
        end: 30
      },
      {
        portfolio_url: 'YoungEarlGrey',
        start: 31,
        end: 36
      },
      {
        portfolio_url: 'Tapocketa',
        start: 37,
        end: 48
      },
      {
        portfolio_url: 'MotionClub',
        start: 49,
        end: 56
      },
      {
        portfolio_url: 'Lorica',
        start: 57,
        end: 59
      },
      {
        portfolio_url: 'LiamBrazier',
        start: 60,
        end: 67
      },
      {
        portfolio_url: 'GaryMayes',
        start: 67,
        end: 74
      },
      {
        portfolio_url: 'Lorica',
        start: 75,
        end: 80
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 81,
        end: 93
      }
    ]
  },
  '/styles/animation/3d': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 3
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 4,
        end: 7
      },
      {
        portfolio_url: 'Lorica',
        start: 8,
        end: 13
      },
      {
        portfolio_url: 'CUBE',
        start: 14,
        end: 19
      },
      {
        portfolio_url: 'StephenTurcotte',
        start: 20,
        end: 25
      },
      {
        portfolio_url: 'CUBE',
        start: 26,
        end: 30
      },
      {
        portfolio_url: 'Lorica',
        start: 31,
        end: 34
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 35,
        end: 40
      },
      {
        portfolio_url: 'PeterNizic',
        start: 41,
        end: 43
      }
    ]
  },
  '/styles/animation/explainers': {
    timings: [
      {
        portfolio_url: 'MarvinTe',
        start: 1,
        end: 6
      },
      {
        portfolio_url: 'Echopic',
        start: 7,
        end: 14
      },
      {
        portfolio_url: 'GaryMayes',
        start: 15,
        end: 18
      },
      {
        portfolio_url: 'Echopic',
        start: 19,
        end: 24
      },
      {
        portfolio_url: 'MarvinTe',
        start: 25,
        end: 37
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 38,
        end: 49
      },
      {
        portfolio_url: 'Echopic',
        start: 50,
        end: 57
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 58,
        end: 63
      }
    ]
  },
  '/styles/animation/character-design': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 4
      },
      {
        portfolio_url: 'Lorica',
        start: 5,
        end: 11
      },
      {
        portfolio_url: 'MotionClub',
        start: 12,
        end: 14
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 16,
        end: 22
      },
      {
        portfolio_url: 'CUBE',
        start: 23,
        end: 28
      },
      {
        portfolio_url: 'Lorica',
        start: 29,
        end: 37
      },
      {
        portfolio_url: 'SeasonofVictory',
        start: 38,
        end: 42
      },
      {
        portfolio_url: 'Tapocketa',
        start: 43,
        end: 51
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 52,
        end: 60
      },
    ]
  },
  '/styles/animation/children': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 12
      },
      {
        portfolio_url: 'Lorica',
        start: 14,
        end: 22
      },
      {
        portfolio_url: 'CUBE',
        start: 24,
        end: 32
      },
      {
        portfolio_url: 'Tapocketa',
        start: 33,
        end: 38
      },
      {
        portfolio_url: 'Lorica',
        start: 39,
        end: 44
      },
      {
        portfolio_url: 'CUBE',
        start: 45,
        end: 55
      },
      {
        portfolio_url: 'Tapocketa',
        start: 56,
        end: 59
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 60,
        end: 68
      },
      {
        portfolio_url: 'CUBE',
        start: 70,
        end: 75
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 76,
        end: 81
      }
    ]
  },
  '/styles/animation/motion-graphics': {
    timings: [
      {
        portfolio_url: 'Lorica',
        start: 1,
        end: 6
      },
      {
        portfolio_url: 'StephenTurcotte',
        start: 7,
        end: 12
      },
      {
        portfolio_url: 'PeterNizic',
        start: 13,
        end: 19
      },
      {
        portfolio_url: 'Tapocketa',
        start: 20,
        end: 25
      },
      {
        portfolio_url: 'GaryMayes',
        start: 26,
        end: 37
      },
      {
        portfolio_url: 'Lorica',
        start: 38,
        end: 47
      },
      {
        portfolio_url: 'SeasonofVictory',
        start: 48,
        end: 56
      }

    ]
  }
}

